import './index.styl';
import '../PlayerPositionModal/index.styl';
import template from './index.jst';
import choosePositionTemplate from '../PlayerPositionModal/index.jst';

import $ from "jquery";
import _ from 'lodash';

import { Model } from 'backbone';
import { View } from 'backbone.marionette';
import { User } from '../../../../models';

import {
	Preloader,
	Modal,
	ErrorsModal,
	isMobileView,
	getSponsorLogo
} from '../../../../utils';

import {
	Bench,
	PlayerPool,
	TeamFieldList,
	TeamFieldPitch,
	TeamControls,
	InfoBar,
	PlayerPopup,
	InvalidTeamMessage
} from '../../index';

import { RoundSlider } from "../../../../../../core/views/components";
import Radio from "backbone.radio";
import Cookie from "../../../../../../core/utils/Storage/Cookie";

const
	silent = { silent: true },
	fieldChannel = Radio.channel('field');

export class TeamBuilder extends View {
	get template() {
		return template;
	}

	regions() {
		return {
			controls: '#team-builder-controls',
			info: '#team-builder-info',
			history_slider: '#team-builder-history-slider',
			left: '#team-builder-left',
			field: '#team-builder-field',
			right: '#team-builder-right',
			popup: '#team-builder-player-popup',
			ad_container: '.ad-container',
			ad_container_mobile: '.ad-container-mobile',
			message_block: '#message-block'
		}
	}

	childViewEvents() {
		return {
			'toggle:layout': 'onToggleLayout',
			'toggle:fantasy:coach': 'onToggleFantasyCoach',

			'team:autofill': 'onAutoFill',
			'team:save': 'onTeamSave',
			'team:clear': 'onTeamClear',

			'player:add': 'onPlayerAdd',
			'player:add:from:popup': 'onPlayerAddFromPopup',
			'player:remove': 'onPlayerRemove',
			'player:favourite': 'onPlayerFavourite',
			'player:substitute': 'onPlayerSubstitute',
			'player:substitute:up': 'onPlayerSubstituteUp',
			'player:substitute:down': 'onPlayerSubstituteDown',
			'player:substitute:cancel': 'onCancelSubstitute',
			'player:set:captain': 'onPlayerSetCaptain',
			'player:set:vice_captain': 'onPlayerSetViceCaptain',
			'player:show:popup': 'onPlayerShowPopup',
			'player:trade:out': 'onPlayerTradeOut',

			'switch:position': 'onSwitchFilterByPosition',
			'toggle:player:pool': 'onTogglePlayerPool',
			'with:coach:banner': 'onToggleCoachBanner',
			'game:started': 'onGameStarted',

			'round:changed': 'onHistoryRoundChange',
		}
	}

	initialize() {
		this.liveScoresIntervalId = null;
		this.waitingForGameStart = false;
		this.history_round = null;
		const cookie_settings = JSON.parse(Cookie.get(`user-${User.id}-is_list_view`) || 'false');
		const is_list_view = cookie_settings || isMobileView();

		this.model = new Model({
			is_list_view,
			substitute: [],
			quick_trade: [],
			is_mobile_view: isMobileView(),
			is_coach_enabled: false,
			selected_stat: 'cost',
			team: this.options.team
		});

		if (!_.size(this.options)) {
			return this;
		}

		if (!User.has_assistant_coach) {
			delete this.options.coach;
		}

		this.onResize = _.debounce(this.onResize.bind(this), 50);

		$(window).on('resize', this.onResize);

		this.listenTo(this.options.team, 'update', this.update);
		this.listenTo(this.options.team, 'update:team', this.onTeamSave);
		this.listenTo(this.options.team, 'autofill:success', this.update);
		this.listenTo(this.options.team, 'save:team:success', this.update);
		this.listenTo(fieldChannel, 'change:stat:field', this.rememberStatField);

		this.listenTo(this.options.rounds, 'sync', this.subscribeToLiveUpdates);

		this.listenTo(
			this.options.trades,
			'make:trade:success',
			team => this.options.team.set(_.first(team), silent)
		);
		this.listenTo(this.options.trades, 'make:trade:errors', ErrorsModal.show);

		this.listenTo(this.model, 'update', this.update);
		this.listenTo(this.model, 'change:is_mobile_view', this.toggleMobileView);

		this.listenTo(this, 'data:requested', this.onDataRequested);

		this.setLayout();
		this.requestData();

		return this;
	}

	onBeforeDestroy() {
		$(window).off('resize', this.onResize);
	}

	rememberStatField(selected_stat) {
		this.model.set({ selected_stat }, silent);

		return this;
	}

	toggleMobileView() {
		const is_mobile_view = this.model.get('is_mobile_view');

		return this.toggleLayoutTypeModelField(is_mobile_view)
			.setLayout()
			.update();
	}

	onResize() {
		this.model.set({
			is_mobile_view: isMobileView()
		});

		return this;
	}

	update() {
		const params = this.getViewParams();
		this.initViews(params);

		return this;
	}

	highlightSaveBtn() {
		this.getChildView('controls').highlightSaveBtn();

		return this;
	}

	onGameStarted() {
		this.waitingForGameStart = true;
		this.subscribeToLiveUpdates();
	}

	subscribeToLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);
		const { rounds, players } = this.options;

		if (rounds.has_active || this.waitingForGameStart) {
			this.liveScoresIntervalId = setTimeout(async () => {
				const requests = _.invokeMap([rounds, players], 'fetch');
				await Promise.all(requests);

				this.trigger('data:requested');
			}, 1000 * 60);
		}

		if (rounds.has_active) {
			this.waitingForGameStart = false;
		}
	}

	getDoubleScoreLeaderId() {
		const
			{ captain, vice_captain } = this.options.team.get('lineup'),
			is_preseason = this.options.rounds.is_preseason,
			history_round = this.options.rounds.get(this.history_round),
			round = history_round || this.options.rounds.last_round,
			cap = this.options.players.get(captain),
			params = { round: round.toJSON(), is_preseason },
			cap_is_played = cap && cap.alreadyPlayed(params);

		if (cap_is_played) {
			return cap.hasScores(params) ? captain : vice_captain;
		}
	}

	onDataRequested() {
		const
			is_history_mode = Boolean(this.history_round),
			actual_round = this.options.rounds.actual,
			actual_round_json = actual_round.toJSON(),
			is_active_round = this.options.rounds.has_active,
			squads = this.options.squads.toJSON(),
			positions = this.options.positions.toJSON(),
			rounds = this.options.rounds.toJSON(),
			positions_by_id = _.keyBy(positions, 'id'),
			squad_by_id = _.keyBy(squads, 'id'),
			last_completed_round = this.options.rounds.last_completed,
			is_preseason = this.options.rounds.is_preseason,
			history_round = this.options.rounds.get(this.history_round),
			last_round = history_round || this.options.rounds.last_round,
			next_round = this.options.rounds.next,
			coach = User.has_assistant_coach ? this.options.coach.toJSON() : false,
			actual_round_id = actual_round.get('id'),
			next_lockout = this.options.rounds.next_lockout_time,
			{ captain, vice_captain } = this.options.team.get('lineup'),
			leader_id = this.getDoubleScoreLeaderId(),
			bye_rounds = this.options.rounds.future_bye_rounds.map(round => round.toJSON()),
			week_trades_left = this.options.team.get('week_trades_left'),
			venues_by_id = this.options.venues ? _.keyBy(this.options.venues.toJSON(), 'id') : {},

			user_start_round_id = this.options.team.get('start_round'),
			user_start_round = this.options.rounds.get(user_start_round_id),
			is_unlimited_trades = this.options.team.isUnlimitedTrades({
				start_round_id: user_start_round_id,
				start_round: user_start_round
			}),
			team_is_began_to_score = this.options.team.isBeganToScore({
				start_round_id: user_start_round_id,
				start_round: user_start_round
			}),

			scheduled_round_id = this.options.rounds.first_scheduled.get('id'),
			last_round_id = last_round.get('id'),
			is_endseason = this.options.rounds.is_endseason;
		this.options.players.each(player => {
			player
				.setPositionsName({ positions_by_id })
				.setSquadName({ squad_by_id })
				.setStatsCostDividedByTotalPoints()
				.setOpponent({ squad_by_id, round: actual_round_json })
				.setCostChanges({ round_id: last_completed_round.get('id') })
				.setStatsPointsLastRound({
					is_preseason, rounds,
					round_id: last_round.id,
					leader_id: !actual_round.is_scheduled || is_history_mode ? leader_id : null
				});

			if (is_history_mode) {
				player.set({ is_locked: true }, silent);
			}
			else {
				player.setLockedFields({
					is_unlimited_trades,
					is_active_round,
					captain,
					vice_captain,
					week_trades_left,
					is_endseason
				});
			}

			if (User.has_assistant_coach) {
				player
					.setCoachStats({
						coach,
						actual_round_id,
						leader_id,
						scheduled_round_id,
						last_round_id
					})
					.setFutureGamesStats({
						rounds, coach, squad_by_id,
						venues_by_id, actual_round_id
					})
					.setByRound({ bye_rounds });
			}
		});

		this.model
			.set({
				team_is_began_to_score,
				is_unlimited_trades,
				squads,
				squad_by_id,
				positions,
				positions_by_id,
				is_preseason,
				rounds,
				coach,
				next_lockout,
				actual_round_id,
				is_active_round,
				last_round_id,
				scheduled_round_id,
				next_round_id: next_round.get('id'),
				has_assistant_coach: User.has_assistant_coach,
				is_history_mode,
				history_round_id: this.history_round
			}, silent)
			.trigger('update');

		// if (is_active_round) {
		// 	this.subscribeToLiveUpdates();
		// }

		return this;
	}

	getMappedPlayers({
		favourites,
		coach,
		actual_round_id,
		leader_id,
		scheduled_round_id,
		last_round_id
	}) {
		return this.options.players.map(player => {
			player.setFavourite({ favourites });

			if (User.has_assistant_coach) {
				player.setCoachStats({
					coach,
					actual_round_id,
					leader_id,
					scheduled_round_id,
					last_round_id
				});
			}

			player.set({ is_not_counted: false }, { silent: true });

			return player.toJSON();
		})
	}

	getRemainingSalary({ team_value }) {
		const trade_out_player = _.first(this.model.get('quick_trade')) || { cost: 0 };

		return this.options.team.get('salary_cap') - team_value + trade_out_player.cost;
	}

	updateNotCountedPlayers({ not_counted_players, players_by_id }) {
		_.each(not_counted_players, id => players_by_id[id].is_not_counted = true);

		_.each(
			not_counted_players,
			id => this.options.players.get(id).set({
				is_not_counted: true
			})
		);

		return not_counted_players;
	}

	getTeamProjectedScore({ players_by_id }) {
		const is_active_round = this.options.rounds.has_active;
		const is_matches_completed = this.options.rounds.is_matches_completed;
		return User.has_assistant_coach ? this.options.team.getProjScore(
			{ players_by_id, is_active_round, is_matches_completed }
		) : 0;
	}

	getViewParams() {
		const
			favourites = this.options.favourites.get('list'),
			{ captain, vice_captain } = this.options.team.get('lineup'),
			leader_cap = this.options.players.get(captain),
			is_captain_available = leader_cap && leader_cap.isAvailable(),
			leader_id = is_captain_available ? captain : vice_captain,
			{
				squads,
				positions,
				coach,
				is_unlimited_trades,
				next_lockout,
				actual_round_id,
				last_round_id,
				positions_by_id,
				squad_by_id,
				next_round_id,
				is_list_view,
				substitute,
				is_coach_enabled,
				has_assistant_coach,
				is_mobile_view,
				is_active_round,
				team_is_began_to_score,
				is_history_mode,
				history_round_id,
				scheduled_round_id,
				quick_trade,
				selected_stat
			} = this.model.attributes,

			players = this.getMappedPlayers({
				favourites,
				coach,
				actual_round_id,
				leader_id,
				scheduled_round_id,
				last_round_id
			}),

			players_by_id = _.keyBy(players, 'id'),
			team_value = this.options.team.getTeamValue({ players_by_id }),
			remaining_salary = this.getRemainingSalary({ team_value }),
			is_full_lockout = is_history_mode || this.options.rounds.is_full_lockout,
			team_proj_score = this.getTeamProjectedScore({ players_by_id, is_active_round });

		let { team_score, not_counted_players } = (
			is_active_round || is_history_mode ? this.options.team.getTeamScore({
				players_by_id, is_full_lockout
			}) : {}
		);

		/**
		 * Mark emergency players who do not counted in total team scores
		 */
		this.updateNotCountedPlayers({ not_counted_players, players_by_id });

		const is_somebody_playing = this.options.team.isSomebodyPlaying(players_by_id);

		this.model.set({ is_coach_enabled: is_coach_enabled && !is_history_mode }, silent);

		return {
			team: this.options.team.toJSON(),
			team_is_filled: this.options.team.is_filled,
			team_has_players: this.options.team.team_size > 0,
			is_somebody_playing,
			team_value,
			team_proj_score,
			remaining_salary,
			next_lockout,
			squads,
			squad_by_id,
			positions,
			positions_by_id,
			players: this.options.players.toJSON(),
			players_by_id,
			is_list_view,
			is_unlimited_trades,
			team_is_began_to_score,
			substitute,
			actual_round_id,
			last_round_id,
			scheduled_round_id,
			next_round_id,
			has_assistant_coach,
			is_coach_enabled: this.model.get('is_coach_enabled'),
			is_mobile_view,
			is_active_round,
			team_score,
			is_history_mode,
			history_round_id,
			most_recent_round_id: this.options.rounds.most_recent.id,
			quick_trade,
			selected_stat
		};
	}

	async onHistoryRoundChange(round_id) {
		if (!_.isNumber(round_id)) {
			return false;
		}

		this.model.set({ quick_trade: [] }, silent);

		Preloader.show();

		const actual_round_id = parseInt(
			this.model.get('actual_round_id'), 10
		);

		if (!_.isEqual(actual_round_id, round_id)) {
			clearTimeout(this.liveScoresIntervalId);

			this.history_round = round_id;

			await this.options.team.setShowUrl().getData({
				type: 'request:history:team',
				data: {
					id: this.options.team.get('id'),
					round: round_id
				}
			});
		}
		else {
			await this.options.team.setShowMyUrl().fetch();
			this.history_round = null;
			this.subscribeToLiveUpdates();
		}

		this.trigger('data:requested');

		Preloader.hide();
	}

	initViews(params) {
		return this.initControlsView(params)
			.initLeftBarView(params)
			.initFieldView(params)
			.initRightBarView(params)
			.initInfoBarView(params)
			.initHistorySlider(params)
			.initNotificationView(params);
	}

	initInfoBarView(args) {
		this.getChildView('info').init(args);

		return this;
	}

	initHistorySlider({ team, actual_round_id }) {
		const rounds = _.uniqBy(_.keys(team.scoreflow)
			.map(id => ({ id: parseInt(id, 10) }))
			.concat([{ id: actual_round_id }]), 'id');

		if (_.size(rounds) > 1) {
			const sliderView = this.getChildView('history_slider');
			sliderView.$el.removeClass('hidden');

			sliderView.init({
				rounds,
				selected: this.history_round || _.result(_.last(rounds), 'id', 1)
			});
		}

		return this;
	}

	initFieldView(args) {
		this.getChildView('field').init(args);

		return this;
	}

	initRightBarView(args) {
		this.getChildView('right').init(args);

		return this;
	}

	initLeftBarView(args) {
		this.getChildView('left').init(args);

		return this;
	}

	initControlsView(args) {
		this.getChildView('controls').init(args);

		return this;
	}

	initNotificationView(args) {
		this.getChildView('message_block').init(args);

		return this;
	}

	onPlayerShowPopup({ id }) {
		const
			players = this.options.players,
			player = players.get(parseInt(id, 10)).toJSON();

		if (!player) {
			return this;
		}

		const
			{
				actual_round_id,
				last_round_id,
				next_round_id,
				has_assistant_coach,
				is_unlimited_trades,
			} = this.model.attributes,

			is_from_field = this.options.team.isPlayerOnField(player.id),
			is_from_bench = this.options.team.isPlayerOnBench(player.id),
			field_position_key = this.options.team.getPlayerPosition(player.id),
			players_by_id = _.keyBy(players.toJSON(), 'id'),
			team_value = this.options.team.getTeamValue({ players_by_id }),
			remaining_salary = this.options.team.get('salary_cap') - team_value,
			is_in_salary = player.cost <= remaining_salary,
			field_position = (
				_.isNumber(field_position_key) ?
					this.options.positions.get(field_position_key).get('short_name') :
					field_position_key
			),
			sponsor_logo = getSponsorLogo();

		let bench_rank;

		if (is_from_bench) {
			bench_rank = this.options.team.get('lineup').bench.indexOf(player.id) + 1;
		}

		this.showChildView('popup', this.getPlayerPopupView({
			...player,
			bench_rank,
			is_unlimited_trades,
			is_from_field,
			is_from_bench,
			field_position,
			field_position_key,
			actual_round_id,
			last_round_id,
			next_round_id,
			has_assistant_coach,
			sponsor_logo,
			is_in_salary,
			rounds: this.options.rounds
		}));
	}

	getPlayerPopupView(args) {
		return new PlayerPopup({
			model: new Model(args)
		})
	}

	get requestModels() {
		return _.pick(
			this.options,
			'squads', 'rounds', 'players',
			'team', 'favourites', 'coach',
		)
	}

	async requestData() {
		Preloader.show();

		const requests = _.invokeMap(this.requestModels, 'fetch');

		await Promise.all(requests);

		Preloader.hide();

		this.trigger('data:requested');

		return this;
	}

	toggleLayoutTypeModelField(is_list_view) {
		if (!_.isBoolean(is_list_view)) {
			is_list_view = !this.model.get('is_list_view');
		}

		this.model.set({ is_list_view }, silent);

		return this;
	}

	setLayout() {
		const is_list_view = this.model.get('is_list_view');

		this.$el.toggleClass('list-view', is_list_view);

		if (!this.getRegion('controls').hasView()) {
			this.showChildView('controls', new TeamControls());
		}


		if (!this.getRegion('info').hasView()) {
			this.showChildView('info', new InfoBar({
				share: this.options.share,
				team: this.options.team,
				team_info: this.model
			}));
		}

		if (!this.getRegion('left').hasView()) {
			this.showChildView('left', new Bench());
		}

		if (!this.getRegion('right').hasView()) {
			this.showChildView('right', new PlayerPool());
		}

		const field = is_list_view ? new TeamFieldList() : new TeamFieldPitch();

		this.showChildView('field', field);

		if (!this.getRegion('history_slider').hasView()) {
			const slider = new RoundSlider();
			slider.$el.addClass('hidden');
			this.showChildView('history_slider', slider);
		}

		this.showChildView('message_block', new InvalidTeamMessage({
			team: this.options.team.toJSON()
		}));

		return this;
	}

	onToggleLayout({ is_list_view }) {
		if (is_list_view !== this.model.get('is_list_view')) {
			const params = this.getViewParams();

			this.toggleLayoutTypeModelField(is_list_view)
				.setLayout()
				.initFieldView(params);
		}

		return this;
	}

	async onAutoFill() {
		Preloader.show();

		let { success, errors } = await this.options.team.setAutoFillUrl().postData({
			data: this.options.team.lineup,
			type: 'autofill'
		});

		if (success) {
			this.highlightSaveBtn();
		}

		if (_.size(errors)) {
			ErrorsModal.show(errors);
		}

		Preloader.hide();

		return this;
	}

	onToggleFantasyCoach(is_coach_enabled) {
		this.model
			.set({ is_coach_enabled }, silent)
			.trigger('update');
	}

	async onTeamSave() {
		const
			is_in_season = this.model.get('team_is_began_to_score'),
			is_filled = this.options.team.is_filled;

		if (is_in_season && !is_filled) {
			Preloader.hide();

			return false;
		}

		Preloader.show();

		let { success, errors } = await this.options.team.setUpdateUrl().postData({
			data: this.options.team.lineup,
			type: 'save:team'
		});

		if (success) {
			this.highlightSaveBtn();
		}

		if (_.size(errors)) {
			ErrorsModal.show(errors);
		}

		Preloader.hide();

		return this;
	}

	onTeamClear() {
		const team = this.options.team;

		if (confirm('Are you sure you want to clear your team of all players?')) {
			const empty_team = {
				...team.defaults(),
				salary_cap: team.get('salary_cap'),
				name: team.get('name'),
			};

			team.clear()
				.set(empty_team)
				.trigger('update')
				.trigger('update:team');
		}

		return this;
	}

	onPlayerRemove({ id }) {
		this.options.team
			.removePlayer({ id })
			.trigger('update')
			.trigger('update:team');

		return this;
	}

	/**
	 * Show popup with available positions and ask user to choose one.
	 * @param {object} player - JSON object of player
	 * @param {array<int|string>} available_positions - Array of position keys
	 * @return {Promise.<int|boolean>} Return selected position
	 * key or false in case user decline
	 */
	askUserToChoosePosition({ player, available_positions }) {
		const template = choosePositionTemplate({
			player,
			available_positions,
			positions: this.options.positions.toJSON()
		});

		return new Promise(resolve => {
			const onChoosePosition = function(event) {
				let { position } = event.currentTarget.dataset;

				position = position !== 'bench' ? parseInt(position, 10) : position;

				resolve(position);

				this.close();
			};

			Modal.create({
				template,
				events: {
					'click .js-close': 'close',
					'click .js-choose': onChoosePosition
				}
			});
		});
	}

	/**
	 * Get precise position where to set player
	 * @param {object} player - JSON object of player
	 * @param {array<int|string>} available_positions - Array of position keys
	 * @return {Promise.<int|boolean>} Return precise position based
	 * on availability/selected filter or user choose
	 */
	async getPrecisePosition({ player, position: selected_position }) {
		let
			available_positions = this.options.team.getAvailablePositions(player.positions),
			positions_size = _.size(available_positions);

		/**
		 * Newer show bench option in case some another positions is exist.
		 */
		if(available_positions.includes('bench') && positions_size > 1) {
			available_positions = available_positions.filter(pos => pos !== 'bench');
			positions_size = _.size(available_positions);
		}

		return new Promise(resolve => {
			/**
			 * Doesn't do anything in case positions isn't exist.
			 */
			if (!positions_size) {
				return resolve(false);
			}

			/**
			 * Position that chosen in player pool is available
			 */
			if (available_positions.includes(selected_position)) {
				return resolve(selected_position);
			}

			/**
			 * Doesn't do anything in case is mobile view
			 */
			if (this.model.get('is_mobile_view')) {
				return resolve(false);
			}

			/**
			 * If only one positions is available or player has only one position
			 */
			if (positions_size === 1 || _.size(player.positions) === 1) {
				return resolve(_.first(available_positions));
			}

			/**
			 * Ask user to choose one of available positions (excerpt bench).
			 */
			return resolve(this.askUserToChoosePosition({
				player, available_positions
			}));
		});
	}

	async onPlayerAdd({ player, position }) {
		position = await this.getPrecisePosition({
			player, position
		});

		if (!position) {
			if (_.size(this.model.get('quick_trade'))) {
				this.onPlayerTradeOut({ id: player.id });
			}

			return this;
		}

		this.options.team
			.setPlayer({
				position,
				player_id: player.id,
			})
			.trigger('update')
			.trigger('update:team');

		return this;
	}

	onPlayerAddFromPopup({ id }) {
		this.getChildView('right').onPlayerAdd({
			model: this.options.players.get(id)
		});
	}

	async onPlayerTradeOut({ pos, id }) {
		this.model.set({ substitute: [] }, silent);

		const
			quick_trade = this.model.get('quick_trade'),
			player = this.options.players.get(id),
			all_positions = this.options.positions.map(model => model.get('id')),
			possible_positions = pos === 'bench' ? all_positions : [pos],
			is_already_exist = quick_trade.some(value => value.id === id);

		if (is_already_exist) {
			return false;
		}

		quick_trade.push({
			id,
			pos,
			cost: player.get('cost'),
			possible_positions
		});

		if (_.size(quick_trade) === 2) {
			Preloader.show();

			await this.options.trades.setMakeTradeUrl().postData({
				data: {
					"old_player_id": _.first(quick_trade).id,
					"new_player_id": _.last(quick_trade).id,
				},
				type: 'make:trade'
			});

			this.model.set({ quick_trade: [] }, silent);

			Preloader.hide();

			this.trigger('data:requested');

			return false;
		}

		this.model
			.set({ quick_trade }, silent)
			.trigger('update');

		if (this.model.get('is_mobile_view')) {
			this.onTogglePlayerPool();
		}
	}

	onPlayerSubstituteUp({ id }) {
		if (this.options.team.swapBenchUp(id, this.options.players)) {
			this.options.team.trigger('update');
			this.options.team.trigger('update:team');
		}
	}

	onPlayerSubstituteDown({ id }) {
		if (this.options.team.swapBenchDown(id, this.options.players)) {
			this.options.team.trigger('update');
			this.options.team.trigger('update:team');
		}
	}

	onPlayerSubstitute({ id, pos }) {
		this.model.set({ quick_trade: [] }, silent);

		let substitute = this.model.get('substitute'),
			is_already_exist = substitute.some(value => value.id === id);

		if (is_already_exist) {
			return false;
		}

		substitute.push({
			id, pos
		});

		if (_.size(substitute) === 2) {
			this.options.team
				.swapPlayers(substitute)
				.trigger('update:team');

			substitute = [];
		}

		this.model
			.set({ substitute }, silent)
			.trigger('update');

		return this;
	}

	onCancelSubstitute() {
		this.model
			.set({ substitute: [], quick_trade: [] }, silent)
			.trigger('update');

		return this;
	}

	onTogglePlayerPool() {
		const
			$pool = this.getRegion('right').$el;
		// is_mobile = this.model.get('is_mobile_view'),
		// trades = this.model.get('quick_trade'),
		// is_player_pool_open = $pool.hasClass('visible');

		this.getRegion('field').$el.toggleClass('hidden');
		$pool.toggleClass('visible');

		// /**
		//  * On mobile remove highlight from trade out player.
		//  * !!!This functionality breaks mobile due to infinity preloader.!!!
		//  */
		// if(is_mobile && _.size(trades) && is_player_pool_open){
		// 	this.model.set({ quick_trade: [] }, silent);
		// 	this.model.trigger('update');
		// }

		return this;
	}

	onSwitchFilterByPosition(args) {
		this.getChildView('right').switchPositionSelect(args);

		if (this.model.get('is_mobile_view')) {
			this.onTogglePlayerPool();
		}
		else {
			this.getChildView('right').showPlayerPool();
		}

		return this;
	}

	setLeader({ id, leader_type }) {
		const
			player = this.options.players.get(id);

		if (player.get('is_locked')) {
			return this;
		}

		let
			lineup = this.options.team.get('lineup'),
			{ captain, vice_captain } = lineup,
			leaders_list = new Set([captain, vice_captain]),
			is_leader_selected = leaders_list.has(id),
			leaders = { captain, vice_captain };

		if (is_leader_selected) {
			leaders = {
				captain: vice_captain,
				vice_captain: captain
			}
		}
		else {
			leaders[leader_type] = id;
		}

		this.options.team
			.set({
				lineup: {
					...this.options.team.get('lineup'),
					...leaders
				}
			})
			.trigger('update')
			.trigger('update:team');

		return this;
	}

	onPlayerSetCaptain(args) {
		return this.setLeader({ ...args, leader_type: 'captain' });
	}

	onPlayerSetViceCaptain(args) {
		return this.setLeader({ ...args, leader_type: 'vice_captain' });
	}

	async onPlayerFavourite({ id }) {
		Preloader.show();
		await this.options.favourites.toggle(id);

		this.options.team.trigger('update');

		Preloader.hide();

		return this;
	}

	onToggleCoachBanner(is_show_banner) {
		[this.getChildView('left'), this.getChildView('right')].forEach(view => {
			view.setStyleWithCoachBanner(is_show_banner);
		});
	}
}

export default TeamBuilder;